module.exports = __webpack_public_path__ + "img/gonetwork2_4.dcc630e2.png";